const menu = [
    {
        name: '会员信息',
        link: '',
        children: [
            {
                name: '会员维护',
                link: '/layout/update-member-info',
                currentMenuLink: ['/layout/update-member-info'],
            },
            {
                name: '修改密码',
                link: '/layout/update-pass',
                currentMenuLink: ['/layout/update-pass'],
            },
        ]
    },
    {
        name: '会员风采',
        link: '',
        children: [
            {
                name: '上传会员风采',
                link: '/layout/upload-city-style',
                currentMenuLink: ['/layout/upload-city-style'],
            },
            {
                name: '上传驻京美食',
                link: '/layout/upload-food',
                currentMenuLink: ['/layout/upload-food'],
            },
            {
                name: '我的会员风采',
                link: '/layout/my-city-style',
                currentMenuLink: '/layout/my-city-style',
            },
            {
                name: '我的驻京美食',
                link: '/layout/my-food',
                currentMenuLink: ['/layout/my-food', '/layout/recommend-food'],
            }
        ]
    },
    {
        name: '活动报名',
        link: '/layout/event-rigister',
        currentMenuLink: ['/layout/event-rigister'],
        children: []
    },
    {
        name: '信息交流',
        link: '',
        children: [
            {
                name: '上传共享信息',
                link: '/layout/upload-info',
                currentMenuLink: ['/layout/upload-info'],
            },
            {
                name: '上传专报信息',
                link: '/layout/upload-special-info',
                currentMenuLink: ['/layout/upload-special-info'],
            },
            {
                name: '我的信息交流',
                link: '/layout/my-info-pool',
                currentMenuLink: ['/layout/my-info-pool'],
            },
            {
                name: '下载记录',
                link: '/layout/download-record',
                currentMenuLink: ['/layout/download-record'],
            },
        ]
    },
];

export default menu;
